export const SidebarData = [
  {
    tittle: "MAIN",
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: "Dashboard",
        hasSubRoute: false,
        showSubRoute: false,
        route: "/admin-dashboard",
        icon: "la la-tachometer-alt",
        // subMenus: [
        //   // {
        //   //   menuValue: "Patient Dashboard",
        //   //   route: "",
        //   // },
        //   // {
        //   //   menuValue: "Employee Dashboard",
        //   //   route: "/employee-dashboard",
        //   // },
        //   // {
        //   //   menuValue: "Deals Dashboard",
        //   //   route: "/deals-dashboard",
        //   // },
        //   // {
        //   //   menuValue: "Leads Dashboard",
        //   //   route: "/leads-dashboard",
        //   // },
        // ],
      },
      {
        menuValue: "Patient Dashboard",
        hasSubRoute: false,
        showSubRoute: false,
        route: "/patient-dashboard",
        icon: "la la-chart-line",
        subMenus: [],
      },
      {
        menuValue: "Add Patient",
        hasSubRoute: false,
        showSubRoute: false,
        route: "/add-patient",
        icon: "la la-user-plus",
        subMenus: [],
      },
      {
        menuValue: "Add Old Patient",
        hasSubRoute: false,
        showSubRoute: false,
        route: "/add-old-patient",
        icon: "la la-user-clock",
        subMenus: [],
      },
      {
        menuValue: "Patient List",
        hasSubRoute: false,
        showSubRoute: false,
        route: "/patient-list",
        icon: "la la-users",
        subMenus: [],
      },
      
      {
        menuValue: "Employee List",
        hasSubRoute: false,
        showSubRoute: false,
        route: "/profiles",
        icon: "la la-address-book",
        subMenus: [],
      },
      {
        menuValue: "Bulk Upload",
        hasSubRoute: false,
        showSubRoute: false,
        route: "/bulk-upload",
        icon: "la la-cloud-upload-alt",
        subMenus: [],
      },
    ],
  },
];
